import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const WhyChooseSection = () => {
  const reasons = [
    'One call for repairs, labor, and extra hands',
    'Respect for your home, time, and property',
    'Clear communication before and during the job',
    'Clean, efficient work with attention to detail'
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1 scroll-animate-left">
            <img 
              src="https://customer-assets.emergentagent.com/job_swift-rebuild/artifacts/0mdsg0dx_cfb22801-c7d0-4819-9cd8-3189ed3b688c.png"
              alt="Professional Black handyman drilling and installing"
              className="rounded-lg shadow-2xl shadow-red-600/20 w-full h-auto"
            />
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 scroll-animate-right">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Why Homeowners Choose <span style={{ color: '#FFD700' }}>Swift HandyMen</span>
            </h2>
            
            <ul className="space-y-4 mb-8">
              {reasons.map((reason, index) => (
                <li key={index} className="flex items-start">
                  <CheckCircle2 className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-1" />
                  <span className="text-lg text-gray-300">{reason}</span>
                </li>
              ))}
            </ul>

            <p className="text-xl text-gray-400 italic border-l-4 border-red-500 pl-4">
              We're built for the jobs that need real effort — whether it's fixing what's broken or helping you move, lift, and get it done safely.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
